<template>
    <div class="set-signature">
        <pay-box title="签章设置">
            <div class="content">
                <div class="label">企业印章图片</div>
                <div v-if="params.enterprise_seal_image_url" class="image-container" :style="{backgroundImage:`url(${params.enterprise_seal_image_url})`}">
                    <div class="image-opera">
                        <a-button @click="delImage" type="link">
                            <span class="upload-del"></span>
                        </a-button>
                        <a-button @click="preview" type="link">
                            <span class="upload-fd"></span>
                        </a-button>
                    </div>
                </div>
                <div class="img" v-else>
                    <a-upload name="image" list-type="picture-card" class="uploader" :show-upload-list="false"
                        :action="fullAction" :before-upload="beforeUpload" @change="handleChange">
                        <div>
                            <a-icon style="font-size: 30px;" class="up-icon" :type="loading ? 'loading' : 'upload'" />
                        </div>
                    </a-upload>
                </div>
            </div>
            <div class="content">
                <div class="label">签名前是否需要身份实名认证</div>
                <div class="switch">
                    <a-switch checked-children="开" un-checked-children="关" default-checked @change="onChange" />
                </div>
            </div>
            <div class="form">
                <div class="label">企业名称</div>
                <div class="input">
                    <a-input v-model="params.enterprise_name" placeholder="请输入" size="large" style="border-radius: 0;" />
                </div>
            </div>
            <div class="form">
                <div class="label">联系地址</div>
                <div class="input">
                    <a-input v-model="params.enterprise_address" placeholder="请输入" size="large" style="border-radius: 0;" />
                </div>
            </div>
            <div class="form">
                <div class="label">联系电话</div>
                <div class="input">
                    <a-input v-model="params.enterprise_phone" placeholder="请输入" size="large" style="border-radius: 0;" />
                </div>
            </div>
            <div class="form">
                <div class="label">联系人</div>
                <div class="input">
                    <a-input v-model="params.legal_representative_name" placeholder="请输入" size="large" style="border-radius: 0;" />
                </div>
            </div>
        </pay-box>

        <div class="btn-box">
            <button class="btn" @click="submit">保存</button>
        </div>

        <template v-if="showPreviewModal">

            <a-modal class="img-modal" v-model="showPreviewModal" :footer="null">
                <img @click="showPreviewModal = false" :src="params.enterprise_seal_image_url" alt="avatar"/>
            </a-modal>

        </template>
    </div>
</template>

<script>
import api from '@/repo/api';
import auth from "@/auth";
import PayBox from "@/views/AST/Pay/Step/PayBox";
export default {
    name: "setSignature",
    components: {
        PayBox
    },
    props: {
        info: {
            default:() => {}	
        }
    },
    data() {
        return {
            loading: false,
            fullAction: '',
            params:{
                enterprise_seal_image_url: '', // 企业印章图片
                need_real_name_verified: 1, // 签名前是否需要身份实名认证 1 是 0 否
                enterprise_name: '', // 企业名称
                enterprise_address: '', // 企业地址
                enterprise_phone: '', // 企业电话
                legal_representative_name: '', // 法人姓名
            },
            showPreviewModal: false,
        }
    },
    mounted() {
        this.getInfo();
        this.buildFullAction();
    },
    computed: {
        // 上传地址
        action() {
            return api.colUrl('/ast-contract/enterprise-seal-image-upload')
        }
    },
    methods: {
        getInfo(){
            if (this.info) {
                this.params = this.info;
            }
        },
        // 保存
        submit(){
            console.log('params: ', this.params);
            if (!this.params.enterprise_seal_image_url) {
                return this.$message.error('请上传企业印章图片!');
            }
            if (!this.params.enterprise_name) {
                return this.$message.error('请输入企业名称!');
            }
            if (!this.params.enterprise_address) {
                return this.$message.error('请输入企业地址!');
            }
            if (!this.params.enterprise_phone) {
                return this.$message.error('请输入企业电话!');
            }
            if (!this.params.legal_representative_name) {
                return this.$message.error('请输入法人姓名!');
            }
            api.post('/ast-contract/update-contract-info', this.params, (res) => {
                if (res.code === 0) {
                    this.$message.success('已成功保存，手机端须重新进入小程序方可生效')
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 删除图片
        delImage() {
            this.params.enterprise_seal_image_url = '';
        },
        // 预览
        preview() {
            this.showPreviewModal = true;
        },
        // 切换
        onChange(checked) {
            console.log('checked: ', checked);
            this.params.need_real_name_verified = checked;
        },
        // 构建完整的请求地址
        buildFullAction() {
            let appId = localStorage['mini_app_id'];

            if (this.action.indexOf('?') === -1) {
                this.fullAction =  this.action + '?token=' + auth.getToken() + '&_mini_app_id=' + appId;
                return;
            }

            this.fullAction = this.action + '&token=' + auth.getToken() + '&_mini_app_id=' + appId;
        },
        // 上传回调
        handleChange(info) {
            if (info.file.status === 'uploading') {
                this.loading = true;
                return;
            }
            if (info.file.status === 'done') {

                let response = info.file.response;

                // 抠图失败
                if (response.code != 0) {
                    this.loading = false;
                    return this.$message.error(response.msg)
                }

                this.params.enterprise_seal_image_url = response.data.url;
                this.loading = false;
            }
        },
        // 上传前回调
        beforeUpload(file) {
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isJpgOrPng) {
                this.$message.error('你只能上传jpg,png文件!');
            }
            const isLt1M = file.size / 1024 / 1024 < 2;
            if (!isLt1M) {
                this.$message.error('图片必须小于4M!');
            }
            return isJpgOrPng && isLt1M;
        },
    }
}
</script>

<style lang="less" scoped>
.content {
    display: flex;
    margin-bottom: 28px;

    .label {
        color: #333333;
        font-size: 16px;
        margin-right: 16px;
    }

    .img {
        width: 164px;
        height: 164px;
        img{
            width: 100%;
            height: 100%;
        }
    }
}

.form{
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    .label {
        width: 80px;
        color: #333333;
        font-size: 16px;
        margin-right: 16px;
    }
    .input{
        width: 500px;
    }
}
.btn-box {
    margin-top: 24px;
}

/deep/ .uploader .ant-upload {
    width: 164px !important;
    height: 164px !important;
}

.image-container {
    position: relative;
    width: 164px;
    height: 164px;
    background-size: contain;
    &:hover .image-opera {
        display: flex; 
    }
    .image-opera {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: none;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.4);
        line-height: 0;
        span{
            display: block;
            width: 30px;
            height: 30px;
            background-size: 20px;
            background-repeat: no-repeat;
            background-size: contain;
        }
        .upload-del {
            background-image: url("/assets/icons/upload-del.png");
        }

        .upload-fd {
            background-image: url("/assets/icons/upload-fd.png");
        }
    }
}
</style>